module.exports = __webpack_public_path__ + "static/media/Sundays.4e313fb1.png";